<div class="≈flex ≈flex-nowrap ≈gap-3 ≈items-center" [ngClass]="{
        '≈px-6 ≈py-2 ≈border ≈rounded': ['label', 'icon', 'button'].includes(style),
        '≈border-primary-actions-default': selected || (style === 'button' && mode === 'primary'),
        '≈bg-primary-actions-default': selected && style === 'button' && mode === 'primary'
    }">
    <ng-ctemplate *ngIf="(showIcon && ['default', 'label'].includes(style) || !label)" [ngTemplateOutlet]="radioSvg"></ng-ctemplate>
    <ui-icon *ngIf="showIcon && style === 'icon'" [icon]="icon" [mode]="mode"></ui-icon>

    <ui-text *ngIf="!loading" [mode]="labelMode">
        {{label}}
    </ui-text>
</div>


<ui-spinner *ngIf="loading">

</ui-spinner>

<ng-template #radioSvg>
    <svg width="5.5mm"
         height="5.5mm"
         viewBox="0 0 10.500092 10.500095"
         id="svg5"
         xmlns="http://www.w3.org/2000/svg">
        <defs id="defs2"/>
        <g id="layer1" transform="translate(-73.4657,-41.775878)">
            <g id="g9938">
                <circle [ngClass]="{
                            '≈stroke-subdued-text': mode === 'default',
                            '≈stroke-primary-actions-default': mode === 'primary',
                            '≈stroke-primary-actions-disabled': mode === 'disabled'
                        }"
                        style="fill:none;fill-opacity:1;stroke-width:1.17;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke fill markers"
                        id="outer-circle"
                        cx="78.715752"
                        cy="47.025925"
                        r="4.6650472"/>
                <circle *ngIf="selected" [ngClass]="{
                            '≈fill-subdued-text': mode === 'default',
                            '≈fill-primary-actions-default': mode === 'primary',
                            '≈fill-primary-actions-disabled': mode === 'disabled'
                        }"
                        style="fill-opacity:1;stroke:none;stroke-width:1.22957;stroke-dasharray:none;stroke-opacity:1;paint-order:stroke fill markers"
                        id="fill-circle"
                        cx="78.715752"
                        cy="47.025925"
                        r="2.75"/>
            </g>
        </g>
    </svg>
</ng-template>
